module.exports = __webpack_public_path__ + "img/logo-waskita.616618d7.png";